export const menuPatient = {
    menu: [
        {label: 'menu.mesExpertises', icon: '', url: '/dossiers/mes-expertises', children: []},
    ],
    classKey: 'expert'
};
